import { render, staticRenderFns } from "./backhaul.vue?vue&type=template&id=2633a65f&scoped=true&"
import script from "./backhaul.vue?vue&type=script&lang=js&"
export * from "./backhaul.vue?vue&type=script&lang=js&"
import style0 from "./backhaul.vue?vue&type=style&index=0&id=2633a65f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633a65f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2633a65f')) {
      api.createRecord('2633a65f', component.options)
    } else {
      api.reload('2633a65f', component.options)
    }
    module.hot.accept("./backhaul.vue?vue&type=template&id=2633a65f&scoped=true&", function () {
      api.rerender('2633a65f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/backhaul.vue"
export default component.exports